<template>
  <v-autocomplete
    :items="items"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="model_value"
    v-on="inputListeners"
    :loading="loading"
    multiple
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      />
    </template>

    <template #prepend-item>
      <v-list-item
        v-if="model_value.length === items.length"
        class="py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="model_value.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}">
      <template v-if="model_value.indexOf(item.id) < qtde_visivel_selecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="model_value.indexOf(item.id) === qtde_visivel_selecionados">
        <span class="ml-1 text-gray-900">(+ {{model_value.length - qtde_visivel_selecionados}})</span>
      </template>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import {logout} from "@/helpers";
import {buscarMotivosSilenciamentoProduto} from "@/api/compraPorProdutosGerais/NotificacaoBlackList";

export default {
  name: "SysMotivosSilenciarAutocomplete",
  model: {
    prop: "model_value",
    event: "update:modelValue"
  },
  props: {
    model_value: {
      type: Array,
      required: true
    },
    qtde_visivel_selecionados: {
      type: Number,
      default: 1
    },
    cor_loading: {
      type: String,
      default: 'red'
    }
  },
  data: () => ({
    items: [],
    loading: false,
  }),
  computed: {
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            vm.updateModel(values || [])
          }
        }
      )
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    updateModel(values) {
      this.$emit('update:modelValue', values)
    },
    getItems () {
      this.loading = true

      buscarMotivosSilenciamentoProduto()
        .then(motivos => {
          this.items = motivos;
          this.loading = false;
        })
        .catch(logout);
    },
    apendarVirgula (item) {
      const indexOf = this.model_value.indexOf(item.id)
      return indexOf !== this.model_value.length - 1 && indexOf < (this.qtde_visivel_selecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px;
}
.text-gray-900 {
  color: #999;
}
</style>
